import { equals } from 'ramda';
import { useCallback, useEffect, useState } from 'react';
export function useModelStatus(updatedModels, onRemoveModel) {
  const [modelStatus, setModelStatus] = useState({});
  const sortModelUpdates = useCallback(modelsToLoad => {
    if (equals(modelsToLoad, Object.keys(modelStatus))) {
      return;
    }

    const executeModels = modelsToLoad.filter(urn => !modelStatus[urn]);
    const removeModels = Object.keys(modelStatus).filter(key => !modelsToLoad.includes(key));

    if (removeModels.length) {
      onRemoveModel(removeModels);
      setModelStatus(old => {
        const newState = { ...old
        };
        removeModels.forEach(urn => delete newState[urn]);
        return newState;
      });
    }

    if (executeModels.length) {
      executeModels.forEach(urn => {
        setModelStatus(data => ({ ...data,
          [urn]: 'inQueue'
        }));
      });
    }

    if (!modelsToLoad.length) {
      setModelStatus({});
    }
  }, [modelStatus, onRemoveModel]);
  useEffect(() => {
    if (updatedModels) {
      sortModelUpdates(updatedModels);
    }
  }, [sortModelUpdates, updatedModels]);
  const onModelGeometryLoaded = useCallback(urn => {
    setModelStatus(data => ({ ...data,
      [urn]: 'executed'
    }));
  }, []);
  return {
    modelStatus,
    onModelGeometryLoaded
  };
}